import axios from 'axios';
import { toast } from 'react-toastify';
import React from 'react';
import { Trans } from 'react-i18next';

// const domain = 'localhost:3773'; const ssl = false; const baseDomain = domain;
const domain = process.env['REACT_APP_DOMAIN'] || 'api.root.avanga.org'; const ssl = true; const baseDomain = 'avanga.org';

const baseUrl = `http${ssl ? 's' : ''}://${domain}`;
const apiUrl = `${baseUrl}/api`;

const setToken = (token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const clearToken = () => {
  axios.defaults.headers.common.Authorization = '';
};

const get = (methodUrl, params) => axios.get(apiUrl + methodUrl, { params });
const post = (methodUrl, params) => axios.post(apiUrl + methodUrl, params);
const put = (methodUrl, params) => axios.put(apiUrl + methodUrl, params);
const destroy = (methodUrl, params) => axios.delete(apiUrl + methodUrl, { params });

const catchError = async (func) => {
  try {
    return await func();
  } catch (e) {
    if (typeof e.response === 'undefined') {
      toast.error((<Trans>Server is unavailable</Trans>));
    } else {
      toast.error((<Trans>Internal server error</Trans>));
    }
    throw e;
  }
};

export default {
  domain,
  baseDomain,
  baseUrl,
  apiUrl,
  setToken,
  clearToken,
  get,
  post,
  put,
  destroy,
  catchError,
};



// WEBPACK FOOTER //
// ./src/services/api.service.js